import * as S from './styles'

interface IPropsUpdateSkill {
  index: number
  id: string
  levelSkill?: string
  skill?: string
  color?: string
  showDelete?: boolean
  onRemove?: (key: string) => void
}

export const LevelSkillItemTable = ({
  index,
  id,
  levelSkill,
  skill,
  onRemove,
  color,
  showDelete,
}: IPropsUpdateSkill) => {
  return (
    <S.SkillWrapper key={index} align={'middle'} gutter={[10, 10]}>
      <S.LevelTagGroup>
        <S.LevelTag color={color}>{levelSkill ?? 'unknown'}</S.LevelTag>
        <S.ActionGroup></S.ActionGroup>
      </S.LevelTagGroup>
      <S.SkillTitle>{skill ?? 'unknown'}</S.SkillTitle>
      {showDelete && (
        <S.RemoveCircleIconStyled onClick={() => onRemove && onRemove(id)} />
      )}
    </S.SkillWrapper>
  )
}
